import React, { useEffect, useCallback } from 'react'
import PropTypes from 'prop-types'
import compose from 'recompose/compose'
import { connect } from 'react-redux'
import { withI18next } from 'lib/i18n/withI18next'
import { bindActionCreators } from 'redux'
import filterVisibilityDuck, {
  PRODUCT_LIST_LAYOUT_VIEW,
} from 'components/visibility/duck'
import clsx from 'clsx'
import { segmentCategoryLayoutToggleEvent } from 'components/product/product-segment/productSegment'
import styles from './grid-view-buttons.scss'

const GridViewButtons = ({ view, setView, refId, refType }) => {
  const onClickView = useCallback(
    (selectedView) => {
      const view_type =
        selectedView === PRODUCT_LIST_LAYOUT_VIEW.GRID_VIEW ? 'grid' : 'block'
      setView(selectedView)
      segmentCategoryLayoutToggleEvent({
        ref_id: refId,
        ref_type: refType,
        view_type,
      })
    },
    [refId, refType, setView],
  )

  useEffect(() => {
    if (!view) {
      setView(PRODUCT_LIST_LAYOUT_VIEW.GRID_VIEW)
    }
  }, [view, setView])

  return (
    <div className="grid-view-buttons-wrapper">
      <style jsx>{styles}</style>
      <div
        tabIndex="0"
        role="button"
        className="grid-view"
        onClick={() => onClickView(PRODUCT_LIST_LAYOUT_VIEW.GRID_VIEW)}
        onKeyDown={() => onClickView(PRODUCT_LIST_LAYOUT_VIEW.GRID_VIEW)}
      >
        <div
          className={clsx('grid-view__block', {
            'grid-view__block__is-active':
              view === PRODUCT_LIST_LAYOUT_VIEW.GRID_VIEW,
          })}
        />
        <div
          className={clsx('grid-view__block', {
            'grid-view__block__is-active':
              view === PRODUCT_LIST_LAYOUT_VIEW.GRID_VIEW,
          })}
        />
      </div>
      <div
        tabIndex="0"
        role="button"
        className="block-view"
        onClick={() => onClickView(PRODUCT_LIST_LAYOUT_VIEW.BLOCK_VIEW)}
        onKeyDown={() => onClickView(PRODUCT_LIST_LAYOUT_VIEW.BLOCK_VIEW)}
      >
        <div
          className={clsx('block-view__block', {
            'block-view__block__is-active':
              view === PRODUCT_LIST_LAYOUT_VIEW.BLOCK_VIEW,
          })}
        />
      </div>
    </div>
  )
}

GridViewButtons.defaultProps = {
  view: null,
  refId: null,
  refType: 'category',
}

GridViewButtons.propTypes = {
  view: PropTypes.string,
  setView: PropTypes.func.isRequired,
  refId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  refType: PropTypes.string,
}

export default compose(
  connect(
    (state) => ({
      view: state.visibility.view,
    }),
    (dispatch) =>
      bindActionCreators(
        { setView: filterVisibilityDuck.creators.setView },
        dispatch,
      ),
  ),
  withI18next(),
)(GridViewButtons)
